/* 🤖 this file was generated by svg-to-ts */
export const emperorIconRemoveCircle2: {
  name: 'remove_circle_2';
  data: string;
} = {
  name: 'remove_circle_2',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M12 2.002c-5.52 0-10 4.48-10 10 0 5.51 4.48 10 10 10 5.51 0 10-4.49 10-10 0-5.52-4.49-10-10-10Zm4.94 13l-1.95 1.94 -3-2.949 -3 2.949 -1.95-1.95 2.949-3 -2.949-3 1.94-2 3 3 3-2.949 1.94 1.94 -2.949 3 2.949 3Z"/></svg>`
};
